export const enviseer = {
    faqs: [
        { question: "Tell me about Enviseer?"},
        { question: " Who is Enviseer for?"},
         { question: "What Tools Does Enviseer Offer?"},
         { question: "Use cases of Enviseer?"},
      ],
    // Add other company-specific contents here
    // For example: policies, guidelines, resources, etc.
    policies: [
      // ...policy objects
    ],
    guidelines: [
      // ...guideline objects
    ],
    // etc.
  };